import React, { useEffect, useState, useRef } from "react";
import DataTable from "../../../Components/DataTable/DataTable";
import Loading from "../../../Components/Loading/Loading";
import { useRecoilValue, useRecoilState } from "recoil";
import { userData } from "../../../DataContext/DataContext";
import {
    AlertError,
    AlertSuccess,
    AlertWarning,
} from "../../../Components/AlertDialog/AlertDialog";
import axios from "axios";
import { authorization, UrlApi } from "../../../UrlApi/UrlApi";
import Card from "@mui/material/Card";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import DateRange from "../../../Components/DateRange/DateRange";
import moment from "moment/moment";
import { ButtonOther } from "../../../Components/Button/Button";
import * as SiIcons from "react-icons/si";
import RefreshIcon from "@mui/icons-material/Refresh";
import ExportExcel from "../../../Components/ExportExcel/ExportExcel";
import { useParams } from "react-router-dom";

const ReportsWorkSummaryByZone = () => {
    const { type_id, menu_name} = useParams(); 
    const user = useRecoilValue(userData);
    const [loading, setLoading] = useState(false);
    const [documentData, setDocumentData] = useState([]);
    const refContainer = useRef(null);
    const [pageSize, setPageSize] = useState(50);
    const [date, setDate] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        },
    ]);
    const [variable, setVariable] = useState({
        startDate: new Date(),
        endDate: new Date(),
    });

    const columns = [
        {
            title: "ลำดับ",
            field: "list_no",
            filtering: false,
            headerStyle: {
                width: "5%",
                maxWidth: "5%",
            },
            cellStyle: { width: "5%", maxWidth: "5%" },
        },
        {
            title: "รหัสพนักงาน",
            field: "emp_code",
            height: 10,
            headerStyle: {
                width: "10%",
                maxWidth: "10%",
            },
            cellStyle: { width: "10%", maxWidth: "10%" },
        },
        {
            title: "ชื่อ-สกุล",
            field: "fullname",
            height: 10,
            headerStyle: {
                width: "5%",
                maxWidth: "5%",
            },
            cellStyle: { width: "5%", maxWidth: "5%" },
        },
        {
            title: "โซน A",
            field: "zone_a",
            type: 'numeric',
            height: 10,
            headerStyle: {
                width: "5%",
                maxWidth: "5%",
            },
            cellStyle: { width: "5%", maxWidth: "5%" },
        },
        {
            title: "โซน B",
            field: "zone_b",
            type: 'numeric',
            height: 10,
            headerStyle: {
                width: "5%",
                maxWidth: "5%",
            },
            cellStyle: { width: "5%", maxWidth: "5%" },
        },
        // {
        //     title: "โซน B (เขตปริมณฑล)",
        //     field: "zone_b2",
        //     type: 'numeric',
        //     height: 10,
        //     headerStyle: {
        //         width: "10%",
        //         maxWidth: "10%",
        //     },
        //     cellStyle: { width: "10%", maxWidth: "10%" },
        // },
        {
            title: "โซน C",
            field: "zone_c",
            type: 'numeric',
            height: 10,
            headerStyle: {
                width: "5%",
                maxWidth: "5%",
            },
            cellStyle: { width: "5%", maxWidth: "5%" },
        },
        {
            title: "รวม",
            field: "total",
            // type: 'numeric',
            height: 10,
            headerStyle: {
                width: "50%",
                maxWidth: "50%",
            },
            cellStyle: { width: "50%", maxWidth: "50%", paddingLeft: '2.5rem'},
        }
    ];

    useEffect(() => {
        getData(variable.startDate, variable.endDate)
    }, [type_id])

    useEffect(() => {
        getData(variable.startDate, variable.endDate)
    }, [variable, date])

    function datePicker() {
        return (
            <>
                <DateRange
                    onClick={(date) => {
                        variable.startDate = date[0].startDate;
                        variable.endDate = date[0].endDate;
                        getData(date[0].startDate, date[0].endDate);
                    }}
                />
            </>
        );
    }

    const getData = async (startDate, endDate) => {
        const url =
            UrlApi +
            `get_report_work_summary_by_zone?start_date=${moment(startDate).format("YYYY-MM-DD")}
             &end_date=${moment(endDate).format("YYYY-MM-DD")}
             &status_id=${type_id}`;
        await axios
            .get(url, authorization)
            .then((res) => {
                res.data.map((e, idx) => {
                    e.list_no = idx + 1
                })
                setDocumentData(res.data);
            })
            .catch((err) => {
                AlertError(err);
            });
    };

    const exportExcells = () => {
        let columnExport = [];
        columns.map((item) => {
            if (item.title !== "เปิด") {
                columnExport.push(item.title);
            }
        });

        const header = [
            "",
            "รายงานประจำวันที่ " +
            moment(variable.startDate).format("DD/MM/YYYY") +
            " ถึง " +
            moment(variable.endDate).format("DD/MM/YYYY"),
        ];
        const data = documentData.map((item) => {
            return [
                item.list_no,
                item.emp_code,
                item.fullname,
                parseFloat(item.zone_a),
                parseFloat(item.zone_b),
                parseFloat(item.zone_c),
                parseFloat(item.total)
            ];
        });
        ExportExcel(
            data,
            columnExport,
            menu_name,
            menu_name+".xlsx",
            header,
        );
    };

    const HeaderPage = () => {
        return (
            <>
                <div style={{ paddingTop: "10px" }}>
                    <label
                        style={{ marginLeft: "10px", marginTop: "10px", fontSize: "18px" }}
                    >
                        {menu_name}
                    </label>
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                            }}
                        >
                            {datePicker()}
                            <div style={{ marginLeft: '38px' }}>
                                <ButtonOther
                                    onClick={() => {
                                        getData(variable.startDate, variable.endDate);
                                    }}
                                    message="โหลดข้อมูลใหม่"
                                    width="20ch"
                                    startIcon={<RefreshIcon />}
                                    background="#61C495"
                                />
                            </div>

                        </div>
                        <div
                            style={{
                                display: "flex",
                            }}
                        >
                            <div style={{ marginRight: "12px", marginTop: "2px" }}>
                                {/* <TextInput
                                    width="100%"
                                    placeholder="ค้นหา เลขที่บิล, ชื่อ Sales"
                                    onKeyDown={(e) => { }}
                                    value={variable.search}
                                    onChange={(e) => {
                                        if (e.target.value === "") {
                                            variable.page = 0;
                                        }
                                        variable.search = e.target.value;
                                        // getData(variable.page, variable.pageSize, variable.startDate, variable.endDate, e.target.value);
                                    }}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    }
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={() => {
                                                    variable.search = "";
                                                    variable.page = 0;
                                                    // getData(0, variable.pageSize, variable.startDate, variable.endDate, "");
                                                }}
                                                edge="end"
                                            >
                                                <CancelIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                /> */}
                            </div>
                            {
                                <ButtonOther
                                    onClick={() => {
                                        exportExcells();
                                    }}
                                    message="ส่งออก"
                                    width="15ch"
                                    startIcon={<SiIcons.SiMicrosoftexcel />}

                                />
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            <Card
                variant="outlined"
                style={{
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    borderRadius: "10px",
                }}
            >
                {HeaderPage()}
                <DataTable
                    exportButton={false}
                    columns={columns}
                    data={documentData}
                    width="100%"
                    countRowData={documentData.length}
                    pageSize={pageSize}
                />
            </Card>
            <Loading open={variable.loading} />
        </>
    )
}

export default ReportsWorkSummaryByZone;